import { Modal as PDPDialog } from '../../components/Modal';
import { buildSectionUrl, getSectionInnerHTML } from '../../sections/PDP/utils';
import { SizeGuide } from '../../components/SizeGuide';

function getSectionToRender() {
  return {
    id: 'pdp-size-guide-modal',
    section: 'pdp-size-guide',
    selector: '.shopify-section',
  };
}

const sizeGuide = () => {
  function sizeGuideClickHandle(e) {
    e.preventDefault();
    const sectionToRender = getSectionToRender();
    const url = buildSectionUrl([sectionToRender]);

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Response error is not okay');
        }
        return response.json();
      })
      .then((data) => {
        const dialogObj = new PDPDialog(sectionToRender.id);
        dialogObj.setContent(getSectionInnerHTML(data[sectionToRender.section], sectionToRender.selector)).show();

        setTimeout(() => {
          const sizeGuideInstance = new SizeGuide(dialogObj.node.querySelector('.pdp-c-size-guide__wrapper'));
          sizeGuideInstance.init();

          dialogObj.setClose(() => sizeGuideInstance.close());
        }, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  document.querySelector('.pdp-c-atc-size-selector__size-guide-btn')?.addEventListener('click', sizeGuideClickHandle);
  window.addEventListener(
    'hashchange',
    (e) => window.location.hash === '#product_size_guide' && sizeGuideClickHandle(e),
  );
};

export default sizeGuide;
